import { HttpParams } from '@angular/common/http';

export type DashboardBulkSelection =
  | { readonly mode: 'none' }
  | { readonly mode: 'ids'; readonly ids: readonly number[]; readonly searchParams: HttpParams }
  | { readonly mode: 'query'; readonly count: number; readonly searchParams: HttpParams;
      readonly scope?: 'dashboard' | 'all_matching';
      readonly excludedIds?: readonly number[]; readonly addedIds?: readonly number[] };

export function selectionCount(selection: DashboardBulkSelection): number {
  return selection.mode === 'query' ? selection.count - (selection.excludedIds?.length || 0) + (selection.addedIds?.length || 0)
    : selection.mode === 'ids' ? selection.ids.length : 0;
}

export function selectionParams(selection: DashboardBulkSelection): HttpParams {
  if (selection.mode === 'none') return new HttpParams();
  if (selection.mode === 'ids') return selection.searchParams;
  let params = selection.searchParams.set('selectionVersion', '2').set('selectionMode', 'query')
    .set('selectedCompanyCount', selectionCount(selection)).set('selectionScope', selection.scope || 'dashboard');
  if (selection.excludedIds?.length || selection.addedIds?.length) {
    params = params.set('selectionBaseCount', selection.count)
      .set('selectionExcludedIds', JSON.stringify(selection.excludedIds || []))
      .set('selectionAddedIds', JSON.stringify(selection.addedIds || []));
  }
  return params;
}

export function selectionIds(selection: DashboardBulkSelection): number[] {
  return selection.mode === 'ids' ? [...selection.ids] : [];
}

export function validSelectionCount(count: number, matchingCount: number): boolean {
  return Number.isSafeInteger(count) && count > 0 && count <= matchingCount;
}

export function searchFingerprint(params: HttpParams): string {
  return params.keys().filter(key => key !== 'pageNumber' && key !== 'pageSize').sort()
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params.get(key))}`).join('&');
}
